<template>
  <el-dialog
    :visible.sync="visible"
    :title="dialogTitle"
    width="80%"
    center
    :before-close="handleClose"
    class="postSelectorDialog">
    <div class="post-container" v-loading="loadingPosts" element-loading-text="Loading your posts...">
      <div class="post-container-inner">
        <div v-if="!posts.length && doneFirstFetch" style="text-align: center; padding-top: 20px;">
          <div style="font-size:60px;">😕</div>
          <h3>It looks like you don't have any posts...</h3>
          <p class="subtitle">We can't send likes to posts that don't exist, you silly goose.</p>
        </div>
        <el-row :gutter="0" v-if="realPosts.length">
          <el-col :span="4" v-for="post in realPosts" :key="realPosts.indexOf(post)" style="margin-top: 10px;">
            <div style="cursor: pointer;" @click="selectPost(post)">
              <el-avatar style="height:150px; width: 150px;" fit="fill" :src="post.node.thumbnail_src" shape="square"></el-avatar>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="media && media.edges && pageInfo && pageInfo.has_next_page">
          <el-col>
            <div style="text-align: center; padding-top: 10px;">
              <el-button @click="fetchMedia">Load more posts...</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 
    <div class="buttons-right">
      <el-button type="primary">Continue</el-button>
    </div>
    -->
  </el-dialog>
</template>

<script>
import bluebird from 'bluebird';
import { mapGetters } from 'vuex'
import { InstagramAPI } from '../bridge';

export default {
  name: 'PostSelector',
  data () {
    return {
      visible: true,
      loadingPosts: false,
      doneFirstFetch: false,
      // User stuff
      account: {},

      // Media info
      media: null,
      count: 0,
      pageInfo: {},
      posts: [],
      realPosts: [],
      // Selected posts
    }
  },
  created () {
    // Set 
    this.loadingPosts = true;
    // Load initial posts
    this.fetchMedia()
  },
  computed: {
    ...mapGetters([
      'targetAccount'
    ]),
    dialogTitle () {
      return  `Select posts by @${this.targetAccount.profile.username}`
    }
  },
  methods: {
    downloadBase64Image(url) {
      const str = InstagramAPI.remoteImageToBase64(url).then(t => t);
      return str;
    },
    selectPost (post) {
      this.$emit('postSelected', post);
      this.$emit('close', { error: false });
    },
    async fetchMedia () {
      this.loadingPosts = true;
      let good = false;
      let cursor = this.pageInfo && this.pageInfo.end_cursor ? this.pageInfo.end_cursor : 0;
      let media = await InstagramAPI.fetchUserMedia(this.targetAccount.user_id, cursor, 24).catch(err => {
        console.error(err); // eslint-disable-line
        this.$notify.error({
          title: 'Error fetching profile',
          message: `We were unable to fetch your posts for this account. Please make sure your profile is PUBLIC and that your account isn't flagged as "18+ only".`,
          duration: 0,
          position: 'bottom-right'
        });
        return false;
      });
      
      if (!media || !media.headers || !media.headers['content-type'].includes('application/json')) {
        this.$notify.error({
          title: 'Error fetching profile (bad response)',
          message: `We were unable to fetch your posts for this account. Please make sure your profile is PUBLIC and that your account isn't flagged as "18+ only".`,
          duration: 0,
          position: 'bottom-right'
        });
        return false;
      }

      if (media && media.data && media.data.data) {
        media.data = media.data.data
      } else {
        this.$notify.error({
          title: 'Error fetching your posts',
          message: `We were unable to fetch your posts for this account. Please make sure your profile is PUBLIC and that your account isn't flagged as "18+ only".`,
          duration: 0,
          position: 'bottom-right'
        });
        return false;
      }
      if (media.data && media.data && media.data.user) {
        if (media.data.user.edge_owner_to_timeline_media) {
          this.media = media.data.user.edge_owner_to_timeline_media;
          this.pageInfo = this.media.page_info || {};
          this.posts = this.posts.concat(...media.data.user.edge_owner_to_timeline_media.edges);
          good = true;

          if (this.media.count >= 1 && this.media.edges.length === 0) {
            this.$emit('close', {
              error: true,
              message: `We couldn't fetch your posts - this usually means that your account is private. Please set it to public and try again.`
            });
          }
        } 
      }

      this.realPosts = await bluebird.map(this.posts, async post => {
        if (!post.data || post.data === undefined || post.data == null) {
          // post.data = await this.downloadBase64Image(post.node.thumbnail_src);
        }
        return post;
      }, { concurrency: 10 });

      this.$forceUpdate();

      this.doneFirstFetch = true;
      this.loadingPosts = false;
      if (!good) {
        this.$emit('close', {
          error: true,
          message: `An error occurred while loading posts for your account. Please make sure it's not private!`
        });
      }
    },
    handleClose() {
      this.$confirm('Are you sure you want to close the post selector?')
        .then(() => {
          this.$emit('close', {
            error: false,
          });
        });
    }
  }
}
</script>

<style lang="scss">

.postSelectorDialog {
  .el-dialog {
    .el-dialog__body {
      padding-bottom: 10px !important;
    }
  }
}

.post-container {
  padding-bottom: 10px;
  //border-bottom: 1px solid #ebecec;
  .post-container-inner {
    width: 100%;
    height: 500px;
    max-height: 500px;
    overflow-y: scroll;
    padding-right: 17px; /* Increase/decrease this value for cross-browser compatibility */
    box-sizing: content-box;
    &::-webkit-scrollbar {
      width: 10px;  /* Remove scrollbar space */
      height: 100%;
      // background: transparent;  /* Optional: just make scrollbar invisible */
    }
    /* Optional: show position indicator in red */
    &::-webkit-scrollbar-thumb {
      background: #ebecec;
      border-radius: 10px;
    }

  }
}
.buttons-right {
  margin-top: 10px;
  text-align: right;
}
</style>
